<template>
  <div class="">
    <Navbar />
    <div class="home-img py-md-2 kova-bg">
      <div class="human-im container-fluid">
        <div class="row pt-5 pb-md-5">
          <div class="col-sm-0 col-md-2"></div>
          <div class="col-sm-12 col-md-8 mt-5 pt-md-5 px-5">
            <h3
              class="pt-4 text-white font-weight-bold very-bold1 mx-3 text-capitalize"
            >
              Looking for top talent that fit your organization?
            </h3>
            <p
              class="mt-3 ml-sm-5 ml-4 text-white font-size2 font-weight-light"
            >
              Build world class products using top talent that are; Pre-Vetted,
              Continuously Reviewed, & Rated.
            </p>
            <div
              :class="
                `ctrl-vetted-text banner-add-margin ml-4 mb-5 d-flex ${
                  width > 768 ? '' : 'flex-wrap'
                } mt-4`
              "
            >
              <!-- <a-select default-value="lucy" style="width: 120px; background: transparent !important" class="bg-danger" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                            <a-select-option value="lucy">
                                Lucy
                            </a-select-option>
                            <a-select-option value="disabled" disabled>
                                Disabled
                            </a-select-option>
                            <a-select-option value="Yiminghe">
                                yiminghe
                            </a-select-option>
                            </a-select> -->
              <select
                class="custom-select select-style mr-3 mt-3"
                data-style="btn-new"
                v-model="category"
              >
                <option selected value="">Category</option>
                <option
                  v-for="category in categories"
                  :key="category"
                  :value="category"
                  >{{ category }}</option
                >
              </select>
              <select
                class="custom-select select-style mr-3 mt-3"
                data-style="btn-new"
                v-model="experienceLevel"
              >
                <option selected value="">Experience level</option>
                <option v-for="exp in experience" :key="exp" :value="exp">{{
                  exp
                }}</option>
              </select>
              <select
                class="custom-select select-style mr-3 mt-3"
                data-style="btn-new"
                v-model="skill"
              >
                <option selected value="">Skill</option>
                <option v-for="skill in skills" :key="skill" :value="skill">{{
                  skill
                }}</option>
              </select>
              <select
                class="custom-select select-style mr-3 mt-3"
                data-style="btn-new"
                v-model="locate"
              >
                <option selected value="">Location</option>
                <option v-for="loc in location" :key="loc" :value="loc">{{
                  loc
                }}</option>
              </select>
            </div>
            <div class="">
              <button
                class="btn-transparent-kovatek ctrl-size mb-4 mx-3 px-5 py-2 text-uppercase font-weight-bold"
                @click="findTalent"
              >
                find talent
              </button>
            </div>
          </div>
          <div class="col-sm-12 col-md-2"></div>
        </div>
      </div>
    </div>

    <div v-if="showDevs == false">
      <div class="w-75 mx-auto mt-4">
        <h6 class="font-weight-bolder kova-text text-left ml-2 mb-4">
          Top Rated Talents On TalentAlt
        </h6>
        <vueper-slides
          class="no-shadow"
          :bullets="false"
          :arrows="false"
          :visible-slides="
            width > 1230 ? 4 : width > 920 ? 3 : width > 640 ? 2 : 1
          "
          :slide-ratio="1 / 4"
          :dragging-distance="70"
          :fixed-height="width > 640 ? '230px' : '270px'"
          transition-speed="250"
          autoplay
        >
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Idris. A"
                image="developer-3.png"
                specialization="UI/UX Designer"
                charge="32"
                location="Ibadan, Nigeria"
                :skills="['Adobe XD', 'Figma', 'PS']"
                level="senior"
                rating="9.7"
                reviews="20"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Johnson. K"
                image="developer-1.png"
                specialization="Web Dev"
                charge="25"
                location="Lagos, Nigeria"
                :skills="['Django', 'Flask', 'Rails']"
                level="intermediate"
                rating="9.5"
                reviews="56"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Mike. P"
                image="mike.png"
                specialization="Back-end Dev"
                charge="30"
                location="Lagos, Nigeria"
                :skills="['PHP', 'Nodejs', 'Go']"
                level="senior"
                rating="9.6"
                reviews="43"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Amana"
                image="image-032.png"
                specialization="Product Manager"
                charge="18"
                location="Ogun, Nigeria"
                :skills="['Product Management']"
                level="intermediate"
                rating="9.7"
                reviews="73"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Idirs. A"
                image="developer-3.png"
                specialization="UI/UX Designer"
                charge="32"
                location="Ibadan, Nigeria"
                :skills="['Adobe XD', 'Figma', 'PS']"
                level="senior"
                rating="9.4"
                reviews="20"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Adara. W"
                image="developer-2.jpeg"
                specialization="Front-end Dev"
                charge="18"
                location="Ogun, Nigeria"
                :skills="['Reactjs', 'Vue']"
                level="senior"
                rating="9.1"
                reviews="73"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Johnson. K"
                image="developer-1.png"
                specialization="Web Dev"
                charge="25"
                location="Lagos, Nigeria"
                :skills="['Django', 'Flask', 'Rails']"
                level="intermediate"
                rating="9.5"
                reviews="56"
              />
            </template>
          </vueper-slide>
          <vueper-slide>
            <template v-slot:content>
              <TopRatedDev
                name="Mike. P"
                image="mike.png"
                specialization="Back-end Dev"
                charge="30"
                location="Lagos, Nigeria"
                :skills="['PHP', 'Nodejs', 'Go']"
                level="senior"
                rating="9.6"
                reviews="43"
              />
            </template>
          </vueper-slide>
          <!-- <vueper-slide class="bg-success mx-2" v-for="i in 9" :key="i" :title="i.toString()" /> -->
        </vueper-slides>
      </div>

      <div class="container mx-auto mt-5 py-3">
        <h5 class="font-weight-bolder kova-text mb-5">How It Works</h5>
        <div class="row mt-4 mx-auto">
          <div class="col-12 col-md-6 col-lg-3 mt-3">
            <div class="d-flex ml-5 ml-md-0">
              <div class="number">01</div>
              <p class="kova-text font-weight-bolder text-left ml-2">
                Get started with <br />
                your account manager.
              </p>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mt-3">
            <div class="d-flex ml-5 ml-md-0">
              <div class="number">02</div>
              <p class="kova-text font-weight-bolder text-left ml-2">
                Access pre-vetted and <br />
                experienced talents.
              </p>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mt-3">
            <div class="d-flex ml-5 ml-md-0">
              <div class="number">03</div>
              <p class="kova-text font-weight-bolder text-left ml-2">
                Review, interview <br />
                and hire.
              </p>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mt-3">
            <div class="d-flex ml-5 ml-md-0">
              <div class="number">04</div>
              <p class="kova-text font-weight-bolder text-left ml-2">
                Start building <br />
                in minutes.
              </p>
            </div>
          </div>
        </div>
        <button class="px-4 py-2 btn-kovatek my-5">Hire Talent</button>
      </div>
    </div>
    <div class="pt-5 container mx-auto" v-else>
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="talent-width mx-auto">
            <p class="font-weight-bolder kova-text text-left text-capitalize">
              {{ message }}
            </p>
            <div class="mt-4 mb-5">
              <div class="p-4 bg-light border shadow-sm add-rounded">
                <div :key="work" v-for="work in workHistory">
                  <div class="row">
                    <div class="class col-3 col-sm-3 col-md-2 pl-1">
                      <img
                        src="../assets/KOVATEK/IMAGES/developer-1.png"
                        alt=""
                        class="rounded-circle img-height"
                      />
                    </div>
                    <div class="col-9 col-sm-9 col-md-7 text-left">
                      <h5 class="font-weight-bolder">
                        <router-link to="/profile"
                          ><span class="kova-text">{{
                            work.title
                          }}</span></router-link
                        >
                        <img
                          class="ml-1 ml-md-2 mb-1"
                          style="height:22px;"
                          src="../assets/KOVATEK/IMAGES/correct.svg"
                          alt=""
                        />
                        <span class="ml-3"
                          ><img
                            class="mr-1 rating"
                            src="../assets/KOVATEK/IMAGES/best.svg"
                            alt=""
                          /><span
                            class="font-weight-bolder ctrl-size-1 kova-green"
                            >9.5</span
                          ><span class="ml-2 ctrl-size-2 kova-light"
                            >56 reviews</span
                          ></span
                        >
                      </h5>
                      <p>
                        <span class="">Web Developer</span>
                        <span
                          class="ml-3 text-uppercase intermediate ctrl-size-2"
                          >intermediate</span
                        >
                        <span class="font-weight-bolder ctrl-size-2 ml-3"
                          ><font-awesome-icon
                            style="font-size: 14px;"
                            icon="map-marker-alt"
                            class="text-dark mr-1"
                          ></font-awesome-icon
                          >Lagos, Nigeria</span
                        >
                      </p>

                      <p class="text-size2">
                        {{ work.comment }}...
                        <router-link to="/profile"
                          ><span class="ant-color pointer"
                            >see more
                          </span></router-link
                        >
                      </p>
                      <div class="text-left d-flex flex-wrap">
                        <span
                          class="kova-bg-green text-white px-3 py-2 mr-3 mb-3 rounded ctrl-size-3 pointer"
                          v-for="skill in proSkills"
                          :key="skill"
                        >
                          {{ skill }}</span
                        >
                        <span
                          class="px-3 py-2 mr-3 mb-3 rounded ctrl-size-3 pointer"
                          style="background-color: #EFEFEF"
                        >
                          <b>+ more</b></span
                        >
                      </div>
                    </div>

                    <div
                      class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text"
                    >
                      <h6 class="font-weight-bolder kova-light ctrl-size-3">
                        Project completed: 11
                      </h6>
                      <h6 class="font-weight-bolder kova-light ctrl-size-3">
                        Team Work: 4
                      </h6>
                      <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                        <font-awesome-icon
                          :icon="['far', 'bookmark']"
                          class="kova-light"
                          style="font-size: 24px"
                        ></font-awesome-icon>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
                <div class="mt-4">
                  <a-pagination
                    showQuickJumper
                    :defaultCurrent="2"
                    :total="500"
                    @change="peginationChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="mb-4" style="position: sticky; top:80px">
            <SignUp />
          </div>
        </div>
      </div>
    </div>
    <GetHired />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import TopRatedDev from '@/components/TopRatedDev.vue';
import GetHired from '@/components/GetHired.vue';
import SignUp from '@/components/SignUp.vue';

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  name: 'findtalent',
  components: {
    Navbar,
    Footer,
    TopRatedDev,
    VueperSlides,
    VueperSlide,
    GetHired,
    SignUp,
  },
  data() {
    return {
      skills: [
        'React',
        'Angular',
        'Vue',
        'Kotlin',
        'Python',
        'Go',
        'JavaScript',
        'PHP',
        'Nodejs',
        'Django',
        'Flask',
        'Laravel',
        'Java',
        'C#',
        'C++',
        '.NET',
        'Ruby',
        'Scala',
        'Perl',
        'Symfony',
        'Spring',
        'JSF',
        'Others',
      ],
      categories: [
        'Android',
        'IOS',
        'CyberSecurity',
        'Data Engineering',
        'eCommerce',
        'Web Application',
        'Front-end',
        'Back-end',
        'UI/UX',
        'Artificial Intelligence',
        'Blockchain',
        'Integration',
        'Project management',
        'DApps',
        'DevOps',
      ],
      location: ['Nigeria', 'Kenya', 'United States'],
      stacks: [
        'React',
        'Angular',
        'Vue',
        'Kotlin',
        'Python',
        'Go',
        'JavaScript',
        'PHP',
        'Nodejs',
        'Django',
        'Flask',
        'Laravel',
        'Java',
        'C#',
        'C++',
        '.NET',
        'Ruby',
        'Scala',
        'Perl',
        'Symfony',
        'Spring',
        'JSF',
        'Others',
      ],
      workHistory: [
        {
          title: 'Adebayo Mary',
          duration: ' Mar 2016 - Sep 2018',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: 'Adebayo Mary',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
        {
          title: 'Adebayo Mary',
          duration: ' Mar 2016 - Sep 2018',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: 'Adebayo Mary',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
        {
          title: 'Adebayo Mary',
          duration: ' Mar 2016 - Sep 2018',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: 'Adebayo Mary',
          star: 5,
          comment:
            'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
      ],
      proSkills: ['Database', 'Modeling', 'Vue.js'],
      experience: ['Junior Level', 'intermediate Level', 'Senior Level'],
      width: window.innerWidth,
      showDevs: false,
      category: '',
      experienceLevel: '',
      skill: '',
      locate: '',
      message: '',
      param: '',
    };
  },
  methods: {
    findTalent() {
      this.message = `Showing result for ${this.category} Developers with ${
        this.experienceLevel
      } in ${this.locate}`;
      this.showDevs = true;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
    });

    if (this.$route.query.category) {
      // console.log(this.$route)
      this.param = this.$route.query.category.split('-').join(' ');
      this.message = `Showing result for ${this.param} Developers`;
      this.showDevs = true;
    }
  },
};
</script>

<style scoped>
.talent-width {
  max-width: 850px;
}
.ctrl-size {
  font-size: 10px;
}
.ctrl-size-1 {
  font-size: 20px;
}
.ctrl-size-2 {
  font-size: 11px;
}
.ctrl-size-3 {
  font-size: 12px;
}
.ctrl-size-4 {
  font-size: 14px;
}
.select-style {
  background: rgba(255, 255, 255, 0.3);
  border: 0;
  color: #fff;
  font-size: 12px;
}
.select-style option {
  background: #eee;
  color: #000;
  border: 0;
  outline: 0;
}
.select-style option:hover {
  background: #20409a;
  border: 0;
  border: 0;
  outline: 0;
}
.btn-new {
  background-color: #2a3f54;
}
.styled-btn {
  color: #fff;
  border-radius: 25px;
  outline: 0;
  transition: 0.2s;
  font-size: 10px;
}
.styled-btn:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}
.btn-dev-signup {
  background: linear-gradient(to right, rgb(75, 179, 142), rgb(28, 71, 152));
  border: 0;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: solid #20409a 1px;
  color: #20409a;
  padding-top: 10px;
  font-size: 20px;
}
</style>
